/*
 ** Streaming Image Loader based on the Javascript Image Loader by Cuong Tham
 ** See imageloader.js for more informations
 **
 ** This image loader is used specifically for the patch rendering process
 */

var StreamingImageLoader = function (
  viewer,
  url,
  viewer_width,
  viewer_height,
  patch_number
) {
  this.viewer = viewer;
  this.url = url;
  this.image = null;
  this.img_width = viewer_width;
  this.img_height = viewer_height;
  this.patch_number = patch_number;
  this.setupEvent = null;
  this.loadEvent = null;
  this.errorEvent = null;
};

StreamingImageLoader.prototype = {
  load: function () {
    this.image = document.createElement("CANVAS");
    this.image.id = "Sculpteo3DViewerImage";
    this.image.width = this.img_width;
    this.image.height = this.img_height;

    var url = this.url;
    var image = this.image;
    var patch_number = this.patch_number;
    var ctx = this.image.getContext("2d");
    var setupEvent = this.setupEvent;
    var successEvent = this.loadEvent;
    var errorEvent = this.errorEvent;

    viewer.xhr = $.ajax({
      url: url,
      type: "GET",
      dataType: "text",
      beforeSend: function (jqXHR, settings) {
        if (setupEvent != null) setupEvent(url, image);
      },
      success: function (data, textStatus, jqXHR) {
        if (successEvent != null) successEvent(url, image);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        if (errorEvent != null) errorEvent(url, image, jqXHR.status);
      },
      xhr: function () {
        var i = 0;
        var lastPos = 0;
        //var patch_done = 0;
        //var progress = 0;

        var thisXhr = $.ajaxSettings.xhr();
        if (thisXhr) {
          thisXhr.onprogress = function (e) {
            var data = thisXhr.responseText.substring(lastPos);
            if (data.lastIndexOf("<") != -1) {
              i = 0;
              var endPos = data.lastIndexOf("<") + 1;
              lastPos += endPos;
              var p_array = data.substring(0, endPos - 1).split("<");
              p_array = p_array.filter(function (v) {
                return v !== "";
              });
              var p_num = p_array.length;
              //patch_done += p_num;
              while (i < p_num) {
                var p_elems = p_array[i].split("|");
                if (p_elems.length == 5) {
                  if (p_elems[4]) var p_data = atob(p_elems[4]);
                  var patch_w = p_elems[2];
                  var patch_h = p_elems[3];
                  var i_data = ctx.createImageData(patch_w, patch_h);
                  var c_data = i_data.data;
                  for (var j = 0; j < patch_h; ++j) {
                    for (var k = 0; k < patch_w; ++k) {
                      c_data[(patch_h - j - 1) * patch_w * 4 + k * 4] =
                        p_data.charCodeAt(j * patch_w * 4 + k * 4);
                      c_data[(patch_h - j - 1) * patch_w * 4 + k * 4 + 1] =
                        p_data.charCodeAt(j * patch_w * 4 + k * 4 + 1);
                      c_data[(patch_h - j - 1) * patch_w * 4 + k * 4 + 2] =
                        p_data.charCodeAt(j * patch_w * 4 + k * 4 + 2);
                      c_data[(patch_h - j - 1) * patch_w * 4 + k * 4 + 3] =
                        p_data.charCodeAt(j * patch_w * 4 + k * 4 + 3);
                    }
                  }
                  ctx.putImageData(
                    i_data,
                    p_elems[0],
                    this.img_height -
                      parseInt(p_elems[1], 10) -
                      parseInt(patch_h, 10)
                  );
                }
                ++i;
              }
            }
            //progress = (100.0 * (patch_done / parseFloat(patch_number)));
          }.bind(this);
        }
        return thisXhr;
      }.bind(this),
      contentType: false,
      processData: false,
    });
  },
  getImage: function () {
    return this.image;
  },
};
